module.exports = __webpack_public_path__ + "img/5.48417d4f.webp";